import { render } from "./BoardSkeleton.vue?vue&type=template&id=36581fc4"
import script from "./BoardSkeleton.vue?vue&type=script&lang=js"
export * from "./BoardSkeleton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "../less/boardSkeleton.less?vue&type=style&index=0&lang=less&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__